<style lang="scss" scoped>
.desc {
  white-space: pre-line;
  font-weight: 400;
  line-height: 25px;
  color: rgba(29, 35, 45, 0.7);
}
.tags {
  margin: 0 -4px -4px -4px;
  .tag {
    border-radius: 2px;
    margin: 0 4px 8px 4px;
    padding: 4px 8px;
  }
}
.ck-content {
  padding: relative;
}
.blurred {
  filter: blur(4px);
  .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(255, 255, 255, 0.7);
  }
}
.overlay-text {
  position: absolute;
  left: 0;
  margin: auto;
  z-index: 1;
  text-align: center;
  align-self: center;
  width: 100%;

  @media only screen and (max-width: 576px) {
    top: 48px;
    align-self: flex-start;
  }
}
.alert {
  &.alert-warning {
    border: 1px solid var(--primary);
    border-radius: 4px;
    color: var(--primary-dark);
    padding: 15px;
    font-size: 80%;
    margin-bottom: 15px;
  }
}
</style>

<template>
  <div class="py-32 py-md-60">
    <div class="container h-100">
      <div v-if="access" class="row px-lg-44 pb-32">
        <div v-if="tip" class="col-12 col-md-3 mb-32 mb-md-0">
          <div class="mb-32">
            <i-back class="i-14 mr-16 fill-gold"></i-back>
            <router-link class="small text-dark" :to="{ name: 'tips' }"> {{ $t('general.back') }}</router-link>
          </div>
          <h2 class="fw-b">{{ $t('pages.tips.day_x', { day: tip.day }) }}</h2>
          <p v-if="date" class="fw-b">{{ $moment(date, 'YYYY-MM-DD') | moment('dddd') }}</p>
          <p v-if="date" class="small mb-16">{{ $moment(date, 'YYYY-MM-DD') | moment('DD MMMM') }}</p>

          <template v-if="tip.audio_file_previews.length && !this.currentUser.user.trial">
            <p class="fw-b small mb-8">Luisteroefeningen</p>
            <audio class="w-100" style="height:25px" v-for="(audio, index) in tip.audio_file_previews" :key="index" :src="audio.default" controls></audio>
          </template>
        </div>
        <div v-if="tip" class="col-12 col-md-8">
          <h4 class="fw-b mb-24">{{ tip.title }}</h4>
          <div v-if="(['rate.initial_no_follow_up', 'rate.upgrade_no_follow_up'].includes(currentUser.user.rate) && !currentUser.user.trial)" class="alert alert-warning">
            Beste <strong>{{ currentUser.first_name }},</strong> <br />
            <br />
            Je hebt gekozen voor de slaaptraining <strong>zonder</strong> persoonlijke begeleiding. <br />
            In de teksten en filmpjes kan er een referentie zijn naar persoonlijke begeleiding, vragen stellen, videobellen met je psycholoog. Dit aanbod is enkel voor de deelnemers van de persoonlijke begeleiding.
          </div>
          <div v-if="(['rate.initial_diy', 'rate.upgrade_diy'].includes(currentUser.user.rate) && !currentUser.user.trial)" class="alert alert-warning">
            Beste <strong>{{ currentUser.first_name }},</strong> <br />
            <br />
            Je hebt gekozen voor de slaaptraining <strong>Doe-het-zelf-aanpak</strong><br />
            In de teksten en filmpjes kan er een referentie zijn naar persoonlijke begeleiding, vragen stellen, videobellen met je psycholoog. Dit aanbod is enkel voor de deelnemers van de persoonlijke begeleiding.
          </div>
          <div v-if="!this.currentUser.user.trial" class="ck-content" v-html="tip.content"></div>
          <div v-else>
            <div class="ck-content" v-html="tip.preview"></div>
            <div class="position-relative d-flex mt-32 border border-gray-light p-16">
              <div class="overlay-text">
                <div class="w-75 m-auto">
                  <h4 class="fw-b text-primary-dark">{{ $t('pages.tips.purchase_plan_to_unlock_tip_title') }}</h4>
                  <p class="mb-16">{{ $t('pages.tips.purchase_plan_to_unlock_tip_desc') }}</p>
                  <a href="#" @click="$modal.show('purchase-plan')" class="btn btn-primary">{{ $t('pages.tips.purchase_plan_to_unlock_tip_cta') }}</a>
                </div>
              </div>
              <div class="blurred">
                <div class="overlay"></div>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                <br /><br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                <br /><br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row h-100">
        <div class="col-auto m-auto">
          <image-no-access height="300"></image-no-access>
          <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_tip_access') }}</h4>
          <p class="text-center">{{ $t('errors.no_tip_access_desc') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tip: null,
    access: true,
    locked: true,
    date: null,
  }),
  mounted() {
    if (this.$route.params.id <= this.currentUser.user.current_day || this.currentUser.user.current_day === 0)
      this.$store.dispatch('tips/readUserTip', { user_id: this.currentUser.user.id, id: this.$route.params.id }).then(tip => (this.tip = tip));
    else this.access = false;

    this.date = this.$route.query.date;
  },
  filters: {
    striphtml(value) {
      var div = document.createElement('div');
      div.innerHTML = value;
      var text = div.textContent || div.innerText || '';
      return text.slice(0, 255);
    },
  },
  computed: {
    currentUser() {
      return this.$store.getters['user/currentUser'];
    },
  },
};
</script>
